import { resolveComponentFlags as resolveComponentFlags$1, resolveComponentType } from "./utilities.js";
import { AppError, ErrorCode } from "@newxsystems/types";
import { NotImplementedBlock } from "../../components/NotImplementedBlock/NotImplementedBlock.js";
function resolveComponent(componentType, props, ctx) {
  const { factory } = ctx;
  if (!factory) {
    throw new AppError({
      code: ErrorCode.ENGINE_MISSING_FACTORY,
      message: "No component factory registered in the context.",
      hint: "Ensure the factory is set on the server context before rendering."
    });
  }
  if (!componentType?.length) {
    throw new AppError({
      code: ErrorCode.ENGINE_MISSING_COMPONENT,
      message: "Empty component type passed to factory resolution.",
      hint: "Ensure the CMS payload includes a valid component type name."
    });
  }
  const Component = resolveComponentType(factory, componentType);
  if (!Component) {
    const NotImplementedBlock$1 = ctx.factory.resolve("NotImplementedBlock");
    return NotImplementedBlock$1 ?? NotImplementedBlock;
  }
  return Component;
}
function resolveComponentFlags(componentType, props, ctx) {
  const { factory } = ctx;
  if (!factory) {
    throw new AppError({
      code: ErrorCode.ENGINE_MISSING_FACTORY,
      message: "No component factory registered in the context.",
      hint: "Ensure the factory is set on the server context before rendering."
    });
  }
  if (!componentType?.length) {
    throw new AppError({
      code: ErrorCode.ENGINE_MISSING_COMPONENT,
      message: "Empty component type passed to flag resolution.",
      hint: "Ensure the CMS payload includes a valid component type name."
    });
  }
  const flags = resolveComponentFlags$1(factory, componentType);
  return flags;
}
export {
  resolveComponent as default,
  resolveComponent,
  resolveComponentFlags
};
//# sourceMappingURL=resolve-component.js.map
